// extracted by mini-css-extract-plugin
module.exports = {"page":"AuthPage_page__8GdKn","link":"AuthPage_link__2jV85"};